module.exports = require("@swa-ui/core/src/Dialog/Dialog.module.scss");